"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aircraftCategoryTranslated = exports.toDateString = void 0;
const toDateString = (date) => {
    if (date == null)
        return "";
    date = new Date(date);
    let regDate = "" + date.getFullYear();
    regDate = `${pad(date.getDay() + 1, 2)}.${pad(date.getMonth() + 1, 2)}.${regDate}`;
    return regDate;
};
exports.toDateString = toDateString;
const pad = (value, len) => {
    let str = typeof value === "string" ? value : String(value);
    while (str.length < len)
        str = "0" + str;
    return str;
};
const aircraftCategoryMap = {
    Aircraft: "Fly",
    Helicopter: "Helikopter",
    Glider: "Seilfly",
    "Power Glider": "Seilfly",
    "Balloon (hot-air)": "Ballong",
    "Balloon (gas)": "Ballong",
};
const aircraftCategoryTranslated = (value) => {
    if (!value)
        return "";
    return aircraftCategoryMap[value] ? aircraftCategoryMap[value] : value;
};
exports.aircraftCategoryTranslated = aircraftCategoryTranslated;
